import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { PageNotFoundComponent } from '@sondermind/features/page-not-found';
import { IrisButtonModule } from '@sondermind/iris/button';
import { IrisCardModule } from '@sondermind/iris/card';
import { IrisIconButtonModule } from '@sondermind/iris/icon-button';
import { IrisIconComponent } from '@sondermind/iris/icon';
import { PublicFooterComponent } from '@sondermind/features/app-footer';
import { SupportPhoneNumberCardComponent } from '@sondermind/features/support-phone-number-card';
import { InternalLinkModuleComponent } from '@sondermind/features/internal-link-module';
import { ProviderCalendarComponent } from '@sondermind/features/public-facing/provider-calendar';
import { PublicHeaderModule } from '@sondermind/features/app-header';
import { NativeAppInterfaceModule } from '@sondermind/native-app-interface';

import { ConnectCardComponent } from './components/connect-card/connect-card.component';
import { CostEstimatePslComponent } from './components/cost-estimate-psl/cost-estimate-psl.component';
import { DirectoryComponent } from './components/directory/directory.component';
import { LandingPageBannerComponent } from './components/landing-page-banner/landing-page-banner.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { LandingPageHeaderComponent } from './components/landing-page-header/landing-page-header.component';
import { ProviderDetailsComponent } from './components/provider-details/provider-details.component';

@NgModule({
  declarations: [
    DirectoryComponent,
    LandingPageComponent,
  ],
  imports: [
    InternalLinkModuleComponent,
    CommonModule,
    RouterModule,
    PageNotFoundComponent,
    IrisButtonModule,
    IrisCardModule,
    IrisIconButtonModule,
    IrisIconComponent,
    PublicFooterComponent,
    ConnectCardComponent,
    CostEstimatePslComponent,
    LandingPageBannerComponent,
    LandingPageHeaderComponent,
    ProviderDetailsComponent,
    ProviderCalendarComponent,
    PublicHeaderModule,
    SupportPhoneNumberCardComponent,
    NativeAppInterfaceModule,
    MatProgressSpinnerModule,
  ],
  exports: [
    PageNotFoundComponent,
    RouterModule,
    IrisButtonModule,
    ConnectCardComponent,
    DirectoryComponent,
    LandingPageComponent,
    LandingPageHeaderComponent,
    ProviderDetailsComponent,
  ],
})
export class ProviderProfilePageModule { }
